module.exports = __webpack_public_path__ + "img/lawyer-pain-point-2.3275850a.png";